var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("DeleteModal", {
    attrs: {
      visible: _vm.showModal,
      "is-loading": _vm.isLoading,
      "is-submiting": _vm.isSubmiting,
      disabled: !_vm.id,
      description:
        "Deseja realmente excluir este banner? Esta ação não poderá ser desfeita."
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      cancel: _vm.toggleModal,
      confirm: _vm.onSubmit,
      closed: _vm.resetModal
    }
  })
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a9bf5f24", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a9bf5f24","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/banner/BannerDeleteModal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a9bf5f24","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/_macro/banner/BannerDeleteModal.vue
// module chunks = 2